type AppName = 'studio-web' | 'studio-backend'
interface Config {
  serviceName: string | undefined
  grafana: {
    token: string | undefined
  }
  traces: {
    url: string | undefined
    user: string | undefined
  }
  logs: {
    url: string | undefined
    user: string | undefined
  }
  faro: {
    url: string | undefined
    traceHeaders: string | undefined
  }
  envs: {
    enviromentsToMonitor: string | undefined
    currentEnviroment: string | undefined
  }
}

export const config = {
  serviceName: process.env.OBSERVABILITY_SERVICE_NAME,
  grafana: {
    token: process.env.OBSERVABILITY_GRAFANA_ACCESS_TOKEN,
  },
  traces: {
    url: process.env.OBSERVABILITY_TRACES_COLLECTOR_URL,
    user: process.env.OBSERVABILITY_TRACES_COLLECTOR_USER,
  },
  logs: {
    url: process.env.OBSERVABILITY_LOGS_COLLECTOR_URL,
    user: process.env.OBSERVABILITY_LOGS_COLLECTOR_USER,
  },
  faro: {
    url: process.env.NEXT_PUBLIC_OBSERVABILITY_FARO_URL,
    traceHeaders: process.env.NEXT_PUBLIC_OBSERVABILITY_TRACE_HEADERS_CORS_URLS,
  },
  envs: {
    enviromentsToMonitor: process.env.ENVIROMENTS_TO_MONITOR,
    currentEnviroment: process.env.APP_ENV,
  },
}

export const isValidEnvToMonitor = (envsToMonitor: string | undefined, currentEnv: string | undefined): boolean => {
  return envsToMonitor !== undefined &&
    typeof envsToMonitor === 'string' &&
    currentEnv !== undefined &&
    typeof currentEnv === 'string'
    ? envsToMonitor.split(',').includes(currentEnv)
    : false
}

export const getServiceNameByAppName = (appName: AppName): string => {
  const options = {
    'studio-web': process.env.NEXT_PUBLIC_OBSERVABILITY_SERVICE_NAME,
    'studio-backend': process.env.OBSERVABILITY_SERVICE_NAME,
  }

  return options[appName] ?? ''
}

export const getEnvironmentsToMonitorByAppName = (appName: AppName): string => {
  const options = {
    'studio-web': process.env.NEXT_PUBLIC_ENVIROMENTS_TO_MONITOR,
    'studio-backend': process.env.ENVIROMENTS_TO_MONITOR,
  }

  return options[appName] ?? ''
}

export const getAppVersionByAppName = (appName: AppName): string => {
  const options = {
    'studio-web': process.env.NEXT_PUBLIC_OBSERVABILITY_APP_VERSION,
    'studio-backend': '',
  }

  return options[appName] ?? ''
}

export const getAppEnvironmentByAppName = (appName: AppName): string => {
  const options = {
    'studio-web': process.env.NEXT_PUBLIC_ENVIRONMENT,
    'studio-backend': process.env.APP_ENV,
  }

  return options[appName] ?? ''
}

export const isValidConfig = (config: Config): boolean => {
  return Object.values(config).every((val) => (typeof val === 'object' ? isValidConfig(val) : !!val))
}

export const isObservabilityConfigValid = (): boolean => {
  return isValidConfig(config)
}
